import { getUserPosition, geolocationErrorMessage } from './geolocation';

export function formatUserAddress(user) {
  if (!user) return '';
  const addr = String(user.address || '').trim();
  const pin = String(user.pincode || '').trim();
  if (!addr && !pin) return 'No address saved — tap edit to add';
  const parts = [];
  if (pin) parts.push(pin);
  if (addr) parts.push(addr);
  const hasCoords =
    user.addressLat != null &&
    user.addressLng != null &&
    Number.isFinite(Number(user.addressLat)) &&
    Number.isFinite(Number(user.addressLng));
  const line = parts.join(' · ');
  return hasCoords ? `${line} (location pinned)` : line;
}

export async function captureCurrentLocationForAddress() {
  const { latitude, longitude } = await getUserPosition();
  return {
    addressLat: latitude,
    addressLng: longitude,
    addressLabel: `Current location (${latitude.toFixed(5)}, ${longitude.toFixed(5)})`,
  };
}

export { geolocationErrorMessage };
